import React, {
    useEffect,
    useState
}
from "react";

import {
    FontAwesomeIcon
}
from "@fortawesome/react-fontawesome";

import {
    faBuilding,
    faRulerCombined,
    faUsers,
    faLocationDot
}
from "@fortawesome/free-solid-svg-icons";

import {
    functions
}
from "../../../../constants/common-functions";


//============================================================
// Mobile Facility Details
//============================================================

export default function MobileFacilityDetails(
{
    facilityId
})
{

    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [facility, setFacility] =
        useState(null);

    const [loading, setLoading] =
        useState(true);


    //--------------------------------------------------------
    // Load facility
    //--------------------------------------------------------

    useEffect(
        function()
        {

            if(!facilityId)
            {
                return;
            }

            setLoading(
                true
            );

            functions.getObjectFromAjax(
                "/resolutionsoftwareplatform/facility?id=" +
                facilityId,

                null,

                function(result)
                {

                    setFacility(
                        result || {}
                    );

                    setLoading(
                        false
                    );

                }
            );

        },
        [facilityId]
    );


    //========================================================
    // Styles
    //========================================================

    const container =
    {
        width:
            "calc(100% - 20px)",

        margin:
            "12px 10px",

        boxSizing:
            "border-box",

        background:
            "rgba(255,255,255,0.82)",

        backdropFilter:
            "blur(14px)",

        WebkitBackdropFilter:
            "blur(14px)",

        border:
            "1px solid rgba(255,255,255,0.75)",

        borderRadius:
            "14px",

        boxShadow:
            "0 6px 18px rgba(0,0,0,0.10)",

        overflow:
            "hidden"
    };


    const header =
    {
        display:
            "flex",

        alignItems:
            "center",

        height:
            "48px",

        padding:
            "0 14px",

        gap:
            "10px",

        boxSizing:
            "border-box",

        background:
            "linear-gradient(180deg,#2f3339 0%,#262a2f 100%)",

        color:
            "#ffffff"
    };


    const headerIcon =
    {
        display:
            "flex",

        width:
            "30px",

        height:
            "30px",

        alignItems:
            "center",

        justifyContent:
            "center",

        flexShrink:
            0,

        borderRadius:
            "50%",

        background:
            "rgba(255,255,255,0.12)",

        fontSize:
            "12px"
    };


    const headerTitle =
    {
        flexGrow:
            1,

        fontSize:
            "13px",

        fontWeight:
            700
    };


    //--------------------------------------------------------
    // Detail rows
    //--------------------------------------------------------

    const content =
    {
        padding:
            "4px 14px 8px 14px"
    };


    const row =
    {
        display:
            "flex",

        alignItems:
            "center",

        minHeight:
            "52px",

        gap:
            "12px",

        borderBottom:
            "1px solid rgba(38,49,61,0.07)"
    };


    const rowIcon =
    {
        display:
            "flex",

        width:
            "32px",

        height:
            "32px",

        alignItems:
            "center",

        justifyContent:
            "center",

        flexShrink:
            0,

        borderRadius:
            "8px",

        background:
            "#edf5fc",

        color:
            "#3d7bff",

        fontSize:
            "13px"
    };


    const rowContent =
    {
        flexGrow:
            1,

        minWidth:
            0
    };


    const label =
    {
        color:
            "#8A939D",

        fontSize:
            "10px",

        fontWeight:
            500
    };


    const value =
    {
        marginTop:
            "2px",

        color:
            "#26313D",

        fontSize:
            "12px",

        fontWeight:
            600
    };


    const loadingStyle =
    {
        padding:
            "22px",

        color:
            "#8A939D",

        textAlign:
            "center",

        fontSize:
            "12px"
    };


    //========================================================
    // Row helper
    //========================================================

    const renderRow =
        function(icon, rowLabel, rowValue)
        {

            if(
                rowValue === null
                ||
                rowValue === undefined
                ||
                rowValue === ""
            )
            {
                return null;
            }

            return (

                <div style={row}>

                    <div style={rowIcon}>

                        <FontAwesomeIcon
                            icon={icon}
                        />

                    </div>

                    <div style={rowContent}>

                        <div style={label}>
                            {rowLabel}
                        </div>

                        <div style={value}>
                            {rowValue}
                        </div>

                    </div>

                </div>

            );

        };


    //========================================================
    // Render
    //========================================================

    return (

        <div style={container}>

            {/* HEADER */}

            <div style={header}>

                <div style={headerIcon}>

                    <FontAwesomeIcon
                        icon={faBuilding}
                    />

                </div>

                <div style={headerTitle}>
                    Building Details
                </div>

            </div>


            {/* CONTENT */}

            {
                loading
                ?
                <div style={loadingStyle}>
                    Loading building details...
                </div>
                :
                <div style={content}>

                    {
                        renderRow(
                            faBuilding,
                            "Building",
                            facility?.name
                        )
                    }

                    {
                        renderRow(
                            faLocationDot,
                            "Building Code",
                            facility?.code
                        )
                    }

                    {
                        renderRow(
                            faRulerCombined,
                            "Reportable Area",
                            facility?.reportableArea
                        )
                    }

                    {
                        renderRow(
                            faUsers,
                            "Capacity",
                            facility?.capacity
                        )
                    }

                </div>
            }

        </div>

    );

}